// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchaseList_container__UUnv9","card":"PurchaseList_card__gRoY6","title":"PurchaseList_title__qogFY"};